export enum DocumentCategory {
    CATEGORY_REPORT_MONTHLY = 'report-monthly',
    CATEGORY_REPORT_ANNUAL = 'report-annual',
    CATEGORY_REPORT = 'report',
    CATEGORY_JAHRESBEGEHUNG = 'Jahresbegehung',
    CATEGORY_HALBJAHRESBEGEHUNG = 'Halbjahresbegehung',
    CATEGORY_MONATSBEGEHUNG = 'Monatsbegehung',
    CATEGORY_OTHER = 'other',
}
